<div class="order-mods">
  <!-- Field picker: standard order fields + (optionally) custom fields -->
  <mat-form-field class="order-mods__picker" appearance="outline">
    <mat-select
      [formControl]="pickerControl"
      multiple
      [placeholder]="'workflows.builder.select_order_fields' | translate"
      panelClass="order-mods__picker-panel"
    >
      <mat-optgroup [label]="'workflows.builder.order_fields' | translate">
        <mat-option *ngFor="let field of orderFields" [value]="field.key">
          {{ field.i18nLabel | translate }}
        </mat-option>
      </mat-optgroup>
      <mat-optgroup
        *ngIf="customFields.length"
        [label]="'workflows.builder.custom_fields' | translate"
      >
        <mat-option *ngFor="let field of customFields" [value]="'cf:' + field.technicalName">
          {{ field.label }}
        </mat-option>
      </mat-optgroup>
    </mat-select>
  </mat-form-field>

  <!-- Typed sub-forms for each selected field -->
  <div class="order-mods__fields">
    <!-- Shipping date -->
    <div class="order-mods__field" *ngIf="isSelected('shipping_date')">
      <span class="order-mods__field-label">{{ 'workflows.params.shipping_date' | translate }}</span>
      <mat-radio-group class="order-mods__modes" [formControl]="shippingModeControl">
        <mat-radio-button value="absolute">{{ 'workflows.builder.specific_date' | translate }}</mat-radio-button>
        <mat-radio-button value="relative">{{ 'workflows.builder.days_from_execution' | translate }}</mat-radio-button>
      </mat-radio-group>
      <ui-form-field
        *ngIf="shippingModeControl.value === 'absolute'"
        type="datepicker"
        [formControl]="shippingDateControl"
        [placeholder]="'workflows.params.shipping_date' | translate"
        prefixIcon="calendar-cc"
      ></ui-form-field>
      <ui-form-field
        *ngIf="shippingModeControl.value === 'relative'"
        type="number"
        [min]="0"
        [formControl]="shippingDaysControl"
        [suffixText]="'workflows.builder.days' | translate"
        [placeholder]="'workflows.builder.days_placeholder' | translate"
      ></ui-form-field>
    </div>

    <!-- Location (partner_id) -->
    <div class="order-mods__field" *ngIf="isSelected('partner_id')">
      <span class="order-mods__field-label">{{ 'workflows.params.location' | translate }}</span>
      <mat-radio-group class="order-mods__modes" [formControl]="locationModeControl">
        <mat-radio-button value="main">{{ 'workflows.builder.main_location' | translate }}</mat-radio-button>
        <mat-radio-button value="specific">{{ 'workflows.builder.specific_location' | translate }}</mat-radio-button>
      </mat-radio-group>
      <div *ngIf="locationModeControl.value === 'specific'" class="order-mods__location">
        <input
          class="order-mods__location-input"
          [formControl]="locationSearchControl"
          [matAutocomplete]="locationAuto"
          [placeholder]="'workflows.builder.search_location' | translate"
        />
        <mat-autocomplete
          #locationAuto="matAutocomplete"
          class="workflow-order-modifications__autocomplete-panel"
          [displayWith]="displayLocationOption"
          (optionSelected)="selectLocationOption($event.option.value)"
        >
          <mat-option
            *ngFor="let option of filteredLocationOptions$ | async"
            [value]="option"
          >
            {{ option.label }}
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>

    <!-- Internal note (comment) -->
    <div class="order-mods__field" *ngIf="isSelected('comment')">
      <span class="order-mods__field-label">{{ 'workflows.params.internal_note' | translate }}</span>
      <ui-form-field
        type="textarea"
        [fullWidth]="true"
        [formControl]="commentControl"
        [placeholder]="'workflows.params.internal_note' | translate"
      ></ui-form-field>
    </div>

    <!-- Custom fields -->
    <ng-container *ngFor="let field of customFields">
      <div class="order-mods__field" *ngIf="isCustomSelected(field)">
        <span class="order-mods__field-label">{{ field.label }}</span>
        <ng-container [ngSwitch]="field.fieldType">
          <ui-form-field
            *ngSwitchCase="'rich_text'"
            type="textarea"
            [fullWidth]="true"
            [formControl]="customControls[field.technicalName]"
            [placeholder]="field.label"
          ></ui-form-field>

          <ui-form-field
            *ngSwitchCase="'number'"
            type="number"
            [formControl]="customControls[field.technicalName]"
            [placeholder]="field.label"
          ></ui-form-field>

          <ui-form-field
            *ngSwitchCase="'decimal'"
            type="number"
            [step]="0.01"
            [formControl]="customControls[field.technicalName]"
            [placeholder]="field.label"
          ></ui-form-field>

          <div *ngSwitchCase="'boolean'" class="order-mods__toggle">
            <mat-slide-toggle [formControl]="customControls[field.technicalName]"></mat-slide-toggle>
          </div>

          <ui-form-field
            *ngSwitchCase="'date'"
            type="datepicker"
            [formControl]="customControls[field.technicalName]"
            [placeholder]="field.label"
            prefixIcon="calendar-cc"
          ></ui-form-field>

          <ui-form-field
            *ngSwitchCase="'single_select'"
            type="select"
            [formControl]="customControls[field.technicalName]"
            [placeholder]="('common.select' | translate) + '...'"
            [options]="customSelectOptions(field)"
          ></ui-form-field>

          <ui-form-field
            *ngSwitchCase="'multi_select'"
            type="select"
            [multiple]="true"
            [formControl]="customControls[field.technicalName]"
            [placeholder]="('common.select' | translate) + '...'"
            [options]="customSelectOptions(field)"
          ></ui-form-field>

          <ui-form-field
            *ngSwitchCase="'url'"
            type="url"
            [formControl]="customControls[field.technicalName]"
            [placeholder]="field.label"
          ></ui-form-field>

          <ui-form-field
            *ngSwitchCase="'email'"
            type="email"
            [formControl]="customControls[field.technicalName]"
            [placeholder]="field.label"
          ></ui-form-field>

          <ui-form-field
            *ngSwitchDefault
            type="text"
            [formControl]="customControls[field.technicalName]"
            [placeholder]="field.label"
          ></ui-form-field>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
